var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18749",
    "data-name": "Group 18749",
    transform: "translate(-1836 -280)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1836 280)",
    fill: "#f9c2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12036",
    "data-name": "Path 12036",
    d: "M5408,1088.6a.6.6,0,0,0,1.2,0V1085a.6.6,0,0,0-1.2,0Zm2.4,0a.6.6,0,0,0,1.2,0V1085a.6.6,0,0,0-1.2,0Zm2.4,0a.6.6,0,0,0,1.2,0V1085a.6.6,0,0,0-1.2,0Zm-6.04,1.843-.56-7.843h9.6l-.56,7.843a.6.6,0,0,1-.6.557h-7.281a.6.6,0,0,1-.6-.557ZM5417,1080.8a.6.6,0,0,1-.6.6h-10.8a.6.6,0,1,1,0-1.2h3v-.6a.6.6,0,0,1,.6-.6h3.6a.6.6,0,0,1,.6.6v.6h3A.6.6,0,0,1,5417,1080.8Z",
    transform: "translate(-3560 -790)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.d6139349045822ea9f996874c6debede.svg";
export { ForwardRef as ReactComponent };